import { useCallback, useState } from "react";

import { persistPageSize, readPersistedPageSize } from "./tablePageSize";

export const useTablePageSize = (storageKey: string, defaultSize: number) => {
    const [pageSize, setPageSizeState] = useState<number>(() => readPersistedPageSize(storageKey, defaultSize));

    const setPageSize = useCallback(
        (size: number) => {
            setPageSizeState(size);
            persistPageSize(storageKey, size);
        },
        [storageKey],
    );

    return [pageSize, setPageSize] as const;
};
